import React from 'react';
import SpeakerNotesOutlinedIcon from '@mui/icons-material/SpeakerNotesOutlined';
import IconButton from '@mui/material/IconButton';
import { Link } from 'react-router-dom';
import Tooltip from '@mui/material/Tooltip';

export default ({ user: { id }, className }) => (
  <Link to={`/user-log?targetUser=${id}`}>
    <Tooltip title="Audit trail">
      <IconButton aria-label="Audit trail" className={className}>
        <SpeakerNotesOutlinedIcon />
      </IconButton>
    </Tooltip>
  </Link>
);
